import { UAParser } from 'ua-parser-js'

/** 非典型「电脑」形态、不参与师生 WebRTC（与 ua-parser device.type 对齐） */
const BLOCKED_DEVICE_TYPES = new Set(['mobile', 'tablet', 'smarttv', 'console', 'wearable', 'embedded', 'xr'])

/**
 * iPadOS 13+ 常伪装为 Macintosh，需结合触摸点数判断（与视口宽度无关）。
 */
function isLikelyIPadDesktopShell(): boolean {
  if (typeof navigator === 'undefined') return false
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}

function isPcUserAgent(userAgent: string): boolean {
  const r = UAParser(userAgent)
  const deviceType = r.device?.type
  if (deviceType && BLOCKED_DEVICE_TYPES.has(deviceType)) return false

  const osName = (r.os?.name || '').toLowerCase()
  if (osName === 'ios' || osName === 'android') return false

  return true
}

/** PC 且为 /chat 下地址栏带 rtc=1 时视为开启；rtc=0 或其它值、无参数均关闭 */
function isChatRtcQueryEnabled(pathname: string, search: string): boolean {
  if (!pathname.startsWith('/chat')) return false
  return new URLSearchParams(search).get('rtc') === '1'
}

/**
 * 是否允许在本机加载师生 RTM/RTC（UA 桌面判定 + /chat?rtc=1）。
 * 不依赖窗口宽度，以便宽屏手机/折叠屏仍视为移动端。
 *
 * @param url 传入时用其 pathname/search（例如 react-router 的 location），避免 hook 外调用时遗漏 query 变化
 */
export function isTutorCallSupportedClient(ua?: string, url?: { pathname: string; search: string }): boolean {
  if (typeof navigator === 'undefined') return false
  if (isLikelyIPadDesktopShell()) return false
  const userAgent = ua ?? navigator.userAgent ?? ''
  if (!userAgent) return false

  if (!isPcUserAgent(userAgent)) return false

  if (url) {
    return isChatRtcQueryEnabled(url.pathname, url.search)
  }
  if (typeof window === 'undefined') return false
  return isChatRtcQueryEnabled(window.location.pathname, window.location.search)
}
